import React from 'react'
import { ReactComponent as Logo } from 'assets/logo.svg'
import { makeStyles, Paper } from '@material-ui/core'

const useStyles = makeStyles(theme => ({
    container: {
        padding: theme.spacing(2),
        display: 'flex',
        flexGrow: 1,
        justifyContent: 'center',
        alignItems: 'center',
    },
    logo: {
        height: '10%',
        width: '10%',
    },
}))

export default function Loading() {
    const classes = useStyles()
    const { logo } = classes
    return (
        <Paper square>
            <div className="h-screen w-screen flex place-items-center justify-center">
                <Logo className={logo} />
            </div>
        </Paper>
    )
}
